import React from "react";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import {
  groupsFilters,
  groupsMeta,
  selectGroups
} from "../../../../redux/groups/selectors";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { GROUPS_ACTIONS } from "../../../../redux/groups/actions";
import Confirm from "../../../../base/Confirm";
import { dateRender } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";

class _Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }
  static propTypes = {
    groups: PropTypes.array,
    loadGroups: PropTypes.func,
    deleteGroup: PropTypes.func,
    groupsMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    "groups.map": PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.loadGroups();
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this group? This action wil not delete users in this group.",
      {
        title: "Delete Group",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteGroup(id);
      },
      result => {}
    );
  }

  render() {
    const { groups, groupsMeta, filters } = this.props;
    console.log('groups render')
    const breadcrumbs = [];

    const listViewConf = {
      dataSet: groups,
      dataMeta: groupsMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          sort: "updated_at",
          render: zone => dateRender(zone.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/groups"
    };

    return [
      <AdminSubHeader title="Groups" key="subheader" breadcrumbs={breadcrumbs}>
        <Link
          to="/admin/groups/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <ListView
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadGroups: params => dispatch(GROUPS_ACTIONS.loadAllRequest(params)),
  deleteGroup: id => dispatch(GROUPS_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(GROUPS_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    groups: selectGroups(state),
    groupsMeta: groupsMeta(state),
    filters: groupsFilters(state)
  };
};

const Groups = connect(mapStateToProps, mapDispatchToProps)(_Groups);

export default Groups;
